module.exports = __webpack_public_path__ + "static/media/rate-3.44814e88.svg";